module.exports = __webpack_public_path__ + "img/redes.2b0e1485.png";